import { DatePicker, Input } from 'antd'
import moment from 'moment'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { getExpectNumber } from '../../../../../common'
import { SearchDrawerComponent } from '../../../../../components'
import { translate } from '../../../../../languages'
import { RootState } from '../../../../../stores'
import {
  loadTransactions,
  setTransactionFilter,
  setTransactionsLoaded,
} from '../../../../../stores/actions'

const StyledRow = styled.div`
  display: flex;
  margin-bottom: 10px;
`

const StyledLabel = styled.span`
  border: 1px solid #d9d9d9;
  border-right: none;
  padding: 3px 10px;
  background-color: #fafafa;
`

export const SearchTransactionModalComponent: React.FC = () => {
  const dispatch = useDispatch()
  const { language } = useSelector((state: RootState) => state.language)
  const { transactionFilter } = useSelector(
    (state: RootState) => state.transaction
  )
  const [filter, setFilter] = React.useState(transactionFilter)

  const body = (
    <>
      <StyledRow>
        <StyledLabel>{translate('transaction.time', language)}</StyledLabel>
        <DatePicker.RangePicker
          style={{ flexGrow: 1 }}
          placeholder={[
            translate('transaction.time.from', language),
            translate('transaction.time.to', language),
          ]}
          value={[moment(filter.timeFrom), moment(filter.timeTo)]}
          onChange={(e) => {
            setFilter({
              ...filter,
              timeFrom:
                e && e.length === 2 && e[0]
                  ? e[0].toDate().getTime()
                  : filter.timeFrom,
              timeTo:
                e && e.length === 2 && e[1]
                  ? e[1].toDate().getTime()
                  : filter.timeTo,
            })
          }}
        />
      </StyledRow>
      <StyledRow style={{ flexWrap: 'wrap' }}>
        <Input
          placeholder={translate(`transaction.volume.from`, language)}
          addonBefore={translate(`transaction.volume.from`, language)}
          value={filter.volumeFrom}
          type="number"
          style={{ marginBottom: '10px' }}
          allowClear
          onChange={(e: any) =>
            setFilter({
              ...filter,
              volumeFrom: e.target.value,
            })
          }
        />
        <Input
          placeholder={translate(`transaction.volume.to`, language)}
          addonBefore={translate(`transaction.volume.to`, language)}
          value={filter.volumeTo}
          type="number"
          allowClear
          onChange={(e: any) =>
            setFilter({
              ...filter,
              volumeTo: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow style={{ flexWrap: 'wrap' }}>
        <Input
          placeholder={translate(`transaction.unitPrice.from`, language)}
          addonBefore={translate(`transaction.unitPrice.from`, language)}
          value={filter.unitPriceFrom}
          type="number"
          style={{ marginBottom: '10px' }}
          allowClear
          onChange={(e: any) =>
            setFilter({
              ...filter,
              unitPriceFrom: e.target.value,
            })
          }
        />
        <Input
          placeholder={translate(`transaction.unitPrice.to`, language)}
          addonBefore={translate(`transaction.unitPrice.to`, language)}
          value={filter.unitPriceTo}
          type="number"
          allowClear
          onChange={(e: any) =>
            setFilter({
              ...filter,
              unitPriceTo: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow style={{ flexWrap: 'wrap' }}>
        <Input
          placeholder={translate(`transaction.amount.from`, language)}
          addonBefore={translate(`transaction.amount.from`, language)}
          value={filter.amountFrom}
          type="number"
          style={{ marginBottom: '10px' }}
          allowClear
          onChange={(e: any) =>
            setFilter({
              ...filter,
              amountFrom: e.target.value,
            })
          }
        />
        <Input
          placeholder={translate(`transaction.amount.to`, language)}
          addonBefore={translate(`transaction.amount.to`, language)}
          value={filter.amountTo}
          type="number"
          allowClear
          onChange={(e: any) =>
            setFilter({
              ...filter,
              amountTo: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <Input
          placeholder={translate('transaction.station', language)}
          addonBefore={translate('transaction.station', language)}
          value={filter.stationName}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              stationName: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <Input
          placeholder={translate('transaction.pump', language)}
          addonBefore={translate('transaction.pump', language)}
          value={filter.pumpName}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              pumpName: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <Input
          placeholder={translate('transaction.shift', language)}
          addonBefore={translate('transaction.shift', language)}
          value={filter.shiftName}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              shiftName: e.target.value,
            })
          }
        />
      </StyledRow>
    </>
  )

  return (
    <SearchDrawerComponent
      body={body}
      onSearch={() => {
        dispatch(setTransactionsLoaded(false))
        dispatch(
          setTransactionFilter({
            ...filter,
            pageIndex: 1,
            volumeFrom: getExpectNumber(
              true,
              filter.volumeFrom,
              filter.volumeTo
            ),
            volumeTo: getExpectNumber(
              false,
              filter.volumeFrom,
              filter.volumeTo
            ),
            unitPriceFrom: getExpectNumber(
              true,
              filter.unitPriceFrom,
              filter.unitPriceTo
            ),
            unitPriceTo: getExpectNumber(
              false,
              filter.unitPriceFrom,
              filter.unitPriceTo
            ),
            amountFrom: getExpectNumber(
              true,
              filter.amountFrom,
              filter.amountTo
            ),
            amountTo: getExpectNumber(
              false,
              filter.amountFrom,
              filter.amountTo
            ),
          })
        )
        dispatch(loadTransactions())
      }}
    />
  )
}
